export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    title: that.$l('table_label_amzStoreNo') || '店铺编号',
    field: 'amzStoreNo',
    minWidth: 220,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_amzStoreName') || '店铺名称',
    field: 'amzStoreName',
    minWidth: 220,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_regionName') || '所属地区',
    field: 'regionName',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_amazonStoreRegion') || '店铺区域',
    field: 'v_amazonStoreRegion',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
